var map = {
	"./crossroad.png": "./src/Containers/Play/MatchTheWord/content/images/hints/crossroad.png",
	"./cycle.png": "./src/Containers/Play/MatchTheWord/content/images/hints/cycle.png",
	"./dumkal.png": "./src/Containers/Play/MatchTheWord/content/images/hints/dumkal.png",
	"./durbin.png": "./src/Containers/Play/MatchTheWord/content/images/hints/durbin.png",
	"./headphone.png": "./src/Containers/Play/MatchTheWord/content/images/hints/headphone.png",
	"./jacket.png": "./src/Containers/Play/MatchTheWord/content/images/hints/jacket.png",
	"./katahar.png": "./src/Containers/Play/MatchTheWord/content/images/hints/katahar.png",
	"./kisan.png": "./src/Containers/Play/MatchTheWord/content/images/hints/kisan.png",
	"./level2/bandagobi.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/bandagobi.png",
	"./level2/bhanchakotha.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/bhanchakotha.png",
	"./level2/chiyakhura.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/chiyakhura.png",
	"./level2/computer.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/computer.png",
	"./level2/dhupbati.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/dhupbati.png",
	"./level2/gaijatra.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/gaijatra.png",
	"./level2/haatbajar.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/haatbajar.png",
	"./level2/jacket.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/jacket.png",
	"./level2/laltin.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/laltin.png",
	"./level2/makhamali.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/makhamali.png",
	"./level2/nachgan.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/nachgan.png",
	"./level2/panchayebaja.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/panchayebaja.png",
	"./level2/prayogsala.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/prayogsala.png",
	"./level2/sungabha.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/sungabha.png",
	"./level2/vayaguta.png": "./src/Containers/Play/MatchTheWord/content/images/hints/level2/vayaguta.png",
	"./nariwal.png": "./src/Containers/Play/MatchTheWord/content/images/hints/nariwal.png",
	"./paathsala.png": "./src/Containers/Play/MatchTheWord/content/images/hints/paathsala.png",
	"./pooja.png": "./src/Containers/Play/MatchTheWord/content/images/hints/pooja.png",
	"./rachash.png": "./src/Containers/Play/MatchTheWord/content/images/hints/rachash.png",
	"./railgadi.png": "./src/Containers/Play/MatchTheWord/content/images/hints/railgadi.png",
	"./sakar.png": "./src/Containers/Play/MatchTheWord/content/images/hints/sakar.png",
	"./sikari.png": "./src/Containers/Play/MatchTheWord/content/images/hints/sikari.png",
	"./suchikar.png": "./src/Containers/Play/MatchTheWord/content/images/hints/suchikar.png",
	"./tarkari.png": "./src/Containers/Play/MatchTheWord/content/images/hints/tarkari.png",
	"./vayaguto.png": "./src/Containers/Play/MatchTheWord/content/images/hints/vayaguto.png",
	"./volume.svg": "./src/Containers/Play/MatchTheWord/content/images/hints/volume.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/MatchTheWord/content/images/hints sync recursive ^\\.\\/.*$";